import { dimensions as ionDimensions } from './ion/dimensions'

export const sizes = {
  buttons: {
    lg: '36px',
    md: '32px',
    sm: '28px',
    xs: '24px',
  },
  ion: ionDimensions.sizing,
} as const
